import React, { useCallback, useEffect, useState } from "react";
import Loader from "../loader/loader";
import {
    getEquipments,
    deleteEquipments,
    addEquipmentCategory,
    getEquipmentCategory,
    deleteEquipmentCategory,
} from "../../api";
import AddEquipmentModal from "../modals/equipment-modal/add-equipment";
import Pagination from "../common/Pagination";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import AddEquipmentCategory from "../modals/equipment-modal/add-equipment-category";
import { confirmAlert } from "react-confirm-alert";
import Brands from "./Brands";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

function Equipments() {
    const [showSpinner, setShowSpinner] = useState();
    const [searchValue, setSearchValue] = useState("");
    const [equipments, setEquipments] = useState([]);
    const [totalEquipments, setTotalEquipments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [activeEquipment, setActiveEquipment] = useState(null);
    const [openAddCategoryModal, setOpenAddCategoryModal] = useState(false);
    const [categories, setCategories] = useState([]);
    const [cat_errors, setCatErrors] = useState([]);
    const [isCatEdit, setIsCatEdit] = useState(false);
    const [editSelectedCat, setEditSelectedCat] = useState(null);

    useEffect(() => {
        refreshList();
    }, [searchValue]);

    const refreshList = useCallback(
        (page = 1) => {
            getEquipments({
                search_keyword: searchValue,
                page,
            })
                .then((res) => {
                    setEquipments(res.data.equipments.data);
                    setTotalEquipments(res.data.equipments.total);
                    setCurrentPage(res.data.equipments.current_page);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        [searchValue],
    );

    const deleteEquipment = (id) => {
        let confirm = window.confirm("Are you sure!");
        if (confirm) {
            deleteEquipments({ id })
                .then((res) => {
                    refreshList();
                })
                .catch((err) => {});
        }
    };

    const submitCategory = (data, is_edit) => {
        let post_data = data;
        if (is_edit) {
            post_data.id = editSelectedCat.id;
        }
        addEquipmentCategory(post_data)
            .then((res) => {
                if (res.status) {
                    refreshCats();
                    setOpenAddCategoryModal(false);
                    setEditSelectedCat(null);
                    setIsCatEdit(false);
                } else {
                    setCatErrors(res.errors);
                }
            })
            .catch((err) => {});
    };

    const refreshCats = () => {
        getEquipmentCategory()
            .then((res) => {
                setCategories(res.data);
            })
            .catch((err) => {});
    };

    useEffect(() => {
        refreshCats();
    }, []);

    const handleDeleteCategory = (cat_id) => {
        confirmAlert({
            title: "Delete Category",
            message: "Are you sure you want to delete the Category?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        deleteEquipmentCategory(cat_id)
                            .then((res) => {
                                if (res.status) {
                                    refreshCats();
                                } else {
                                    MySwal.fire({
                                        title: <p>{res.message}</p>,
                                        icon: "error",
                                        toast: true,
                                        position: "top-end",
                                        timer: 4000,
                                        timerProgressBar: true,
                                        showConfirmButton: false,
                                        customClass: "margin-top-sweetalert",
                                        didOpen: (toast) => {
                                            toast.addEventListener(
                                                "mouseenter",
                                                Swal.stopTimer,
                                            );
                                            toast.addEventListener(
                                                "mouseleave",
                                                Swal.resumeTimer,
                                            );
                                        },
                                    });
                                }
                            })
                            .catch((err) => {});
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };

    const equipmentTypeLabel = (type) => {
        if (type == "terminal") return "Terminal";
        if (type == "gateway") return "Gateway";
        if (type == "add_on") return "Add On";
    };

    return (
        <>
            {openModal && (
                <AddEquipmentModal
                    show={openModal}
                    handleCloseModel={() => {
                        setActiveEquipment(null);
                        setOpenModal(false);
                        setIsEdit(false);
                    }}
                    refreshList={refreshList}
                    isEdit={isEdit}
                    activeEq={activeEquipment}
                    categories={categories}
                    page={currentPage}
                />
            )}

            {openAddCategoryModal && (
                <AddEquipmentCategory
                    openAddCategoryModal={openAddCategoryModal}
                    close={() => {
                        setOpenAddCategoryModal(false);
                        setEditSelectedCat(null);
                        setIsCatEdit(false);
                    }}
                    submit={submitCategory}
                    errors={cat_errors}
                    clearError={() => setCatErrors([])}
                    isEdit={isCatEdit}
                    editSelectedCat={editSelectedCat}
                />
            )}

            <div className="container-fluid mcc-container">
                <div className="edit-organization">
                    <div className="col-md-1 col-sm-1 col-lg-1"></div>
                    <div className="col-md-10 col-sm-10 col-lg-10">
                        <div className="editTab">
                            <Tabs>
                                <TabList>
                                    <Tab>Equipment</Tab>
                                    <Tab>Equipment Categories</Tab>
                                    <Tab>Brands</Tab>
                                </TabList>
                                <TabPanel>
                                    <div
                                        className="panel-heading"
                                        id="pannel-headingId"
                                    >
                                        <div className="d-flex">
                                            <h4>
                                                Equipment{" "}
                                                <span>({totalEquipments})</span>
                                            </h4>
                                            <button
                                                onClick={(evt) =>
                                                    setOpenModal(true)
                                                }
                                                className="orgbtn"
                                            >
                                                <i className="fa fa-create"></i>{" "}
                                                Add Equipment
                                            </button>
                                        </div>
                                        <div className="header-search">
                                            <form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                }}
                                            >
                                                <input
                                                    value={searchValue}
                                                    type="text"
                                                    placeholder="Search"
                                                    name="search"
                                                    className="search-box"
                                                    onChange={(evt) =>
                                                        setSearchValue(
                                                            evt.target.value,
                                                        )
                                                    }
                                                />
                                                <button
                                                    onClick={(e) =>
                                                        this.handleSearchClick(
                                                            e,
                                                        )
                                                    }
                                                    type="button"
                                                >
                                                    {" "}
                                                    <i className="fa fa-search"></i>{" "}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div
                                        className="table-organizations table-templates mcc-table"
                                        style={{ marginBottom: "6rem" }}
                                    >
                                        <table
                                            className="table table-striped table-responsive template-list"
                                            id="template-index-table"
                                        >
                                            <thead>
                                                <tr>
                                                    <th className="TemplateTitle">
                                                        Equiment Name
                                                    </th>
                                                    <th className="TemplateTitle">
                                                        Type
                                                    </th>
                                                    <th className="TemplateTitle">
                                                        Image
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {equipments.map((eq, index) => (
                                                    <tr key={"tr" + index}>
                                                        <td className="TemplateName">
                                                            <div className="org-full-name">
                                                                <h4>
                                                                    {
                                                                        eq.equipment_name
                                                                    }
                                                                </h4>
                                                            </div>
                                                        </td>
                                                        <td className="TemplateName">
                                                            <div className="org-full-name">
                                                                <h4>
                                                                    {equipmentTypeLabel(
                                                                        eq.equipment_type,
                                                                    )}
                                                                </h4>
                                                            </div>
                                                        </td>
                                                        <td className="TemplateName">
                                                            <img
                                                                src={
                                                                    "img-equipment/" +
                                                                    eq.id
                                                                }
                                                                style={{
                                                                    width: "50px",
                                                                    height: "50px",
                                                                    border: "1px solid #cecece",
                                                                    borderRadius:
                                                                        "50%",
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="addresidual template-add-delete">
                                                            <span
                                                                onClick={(
                                                                    evt,
                                                                ) => {
                                                                    setActiveEquipment(
                                                                        eq,
                                                                    );
                                                                    setIsEdit(
                                                                        true,
                                                                    );
                                                                    setOpenModal(
                                                                        true,
                                                                    );
                                                                }}
                                                            >
                                                                Edit
                                                            </span>

                                                            <span
                                                                onClick={(
                                                                    evt,
                                                                ) =>
                                                                    deleteEquipment(
                                                                        eq.id,
                                                                    )
                                                                }
                                                                className="addresidualIMG"
                                                                style={{
                                                                    marginRight:
                                                                        "40px",
                                                                }}
                                                            >
                                                                <img src="/images/delet.svg " />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <Pagination
                                            onPageChange={refreshList}
                                            itemsCount={totalEquipments}
                                            page={currentPage}
                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div
                                        className="panel-heading"
                                        id="pannel-headingId"
                                    >
                                        <div className="d-flex">
                                            <h4>
                                                Equipment Categories{" "}
                                                <span>({totalEquipments})</span>
                                            </h4>
                                            <button
                                                onClick={(evt) =>
                                                    setOpenAddCategoryModal(
                                                        true,
                                                    )
                                                }
                                                className="orgbtn"
                                            >
                                                <i className="fa fa-create"></i>{" "}
                                                Add Category
                                            </button>
                                        </div>
                                        {/* <div className="header-search">
                      <form onSubmit={(e) => { e.preventDefault() }}>
                        <input value={searchValue} type="text" placeholder="Search" name="search" className="search-box" onChange={(evt) => setSearchValue(evt.target.value)} />
                        <button onClick={(e) => this.handleSearchClick(e)} type="button"> <i className="fa fa-search"></i> </button>
                      </form>
                    </div> */}
                                    </div>
                                    <div
                                        className="table-organizations table-templates mcc-table"
                                        style={{ marginBottom: "6rem" }}
                                    >
                                        <table
                                            className="table table-striped table-responsive template-list"
                                            id="template-index-table"
                                        >
                                            <thead>
                                                <tr>
                                                    <th className="TemplateTitle">
                                                        Category
                                                    </th>
                                                    <th className="TemplateTitle">
                                                        Description
                                                    </th>
                                                    <th
                                                        className="TemplateTitle"
                                                        style={{
                                                            width: "100px",
                                                        }}
                                                    >
                                                        Free Text Enabled
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {categories.map(
                                                    (cat, index) => (
                                                        <tr key={"tr" + index}>
                                                            <td className="TemplateName">
                                                                <div className="org-full-name">
                                                                    <h4>
                                                                        {
                                                                            cat.category
                                                                        }
                                                                    </h4>
                                                                </div>
                                                            </td>
                                                            <td className="TemplateName">
                                                                <div className="org-full-name">
                                                                    <h4>
                                                                        {
                                                                            cat.description
                                                                        }
                                                                    </h4>
                                                                </div>
                                                            </td>
                                                            <td className="TemplateName">
                                                                <div className="org-full-name">
                                                                    <h4>
                                                                        {cat.free_text_enabled ==
                                                                        1
                                                                            ? "Yes"
                                                                            : "No"}
                                                                    </h4>
                                                                </div>
                                                            </td>
                                                            <td className="addresidual template-add-delete">
                                                                <span
                                                                    onClick={(
                                                                        evt,
                                                                    ) => {
                                                                        setEditSelectedCat(
                                                                            cat,
                                                                        );
                                                                        setIsCatEdit(
                                                                            true,
                                                                        );
                                                                        setOpenAddCategoryModal(
                                                                            true,
                                                                        );
                                                                    }}
                                                                >
                                                                    Edit
                                                                </span>

                                                                <span
                                                                    onClick={(
                                                                        evt,
                                                                    ) =>
                                                                        handleDeleteCategory(
                                                                            cat.id,
                                                                        )
                                                                    }
                                                                    className="addresidualIMG"
                                                                    style={{
                                                                        marginRight:
                                                                            "40px",
                                                                    }}
                                                                >
                                                                    <img src="/images/delet.svg " />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ),
                                                )}
                                            </tbody>
                                        </table>
                                        {/* <Pagination onPageChange={refreshList} itemsCount={totalEquipments} page={currentPage} /> */}
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <Brands />
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                    <div className="col-md-1 col-sm-1 col-lg-1"></div>
                </div>

                {showSpinner ? (
                    <div className="mcc-loader">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
            </div>
        </>
    );
}

export default Equipments;
